import { render, staticRenderFns } from "./jobcard.vue?vue&type=template&id=91afb49e"
import script from "./jobcard.ts?vue&type=script&lang=js&external"
export * from "./jobcard.ts?vue&type=script&lang=js&external"
import style0 from "./jobcard.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports